module.exports = __webpack_public_path__ + "img/fondo-movil.e13a753c.svg";